import _extends from "@babel/runtime/helpers/extends";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioBox as CoreRadioBox } from '@vds-core/inputs';
import { BodyConfig, TitleConfig, MicroConfig, TypographyConfig } from '@vds/typography';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds/theme';
var typescale = TypographyConfig.getTypescale();

var RadioBox = function RadioBox(props) {
  var orientation = props.orientation,
      outOfStock = props.outOfStock;

  function _calcTypography(typescale, stacked, component) {
    if (stacked && component === 'text') {
      return TitleConfig.getStyles(typescale, 'mobile', 'small');
    } else if (component === 'text') {
      return BodyConfig.getStyles(typescale, 'desktop', 'small');
    } else {
      return MicroConfig.getStyles(typescale, 'desktop');
    }
  }

  return /*#__PURE__*/React.createElement(CoreRadioBox, _extends({}, props, {
    colorConfig: colors,
    typescale: typescale,
    calcTypography: _calcTypography,
    minHeight: undefined,
    padding: undefined,
    backgroundColor: "transparent",
    borderColor: colors.coolGray3,
    labelMargin: false,
    outOfStock: false,
    hoverState: false,
    disabledState: false,
    activeState: false,
    focusState: false
  }));
};

export default RadioBox;